/**
 * Returns the user's upstream session JWT for Authorization: Bearer
 * headers on EventHub-Backend calls. The backend's jwtAuth middleware
 * validates Entra id_tokens (issuer: login.microsoftonline.com) and
 * SuperTokens access tokens (RS256, validated against the SuperTokens
 * JWKS) — both go through the same header. Resolution order:
 *
 *   1. Entra session if active   → Entra id_token
 *   2. SuperTokens session       → SuperTokens access token
 *   3. neither                   → null (caller should send no auth)
 *
 * Returns null when there's no session yet — happens during the auth
 * flow itself (e.g. POST /api/auth/entra/token where the user is
 * mid-login). Those backend routes don't require auth, so callers can
 * safely omit the header when this returns null.
 *
 * NOTE: this is the UPSTREAM JWT (issuer is the auth provider). For
 * PostgREST calls use the HS256 minted db-jwt via
 * superTokensApiService.getDBJWT() — different signature, different
 * audience, different consumer.
 */
import Session from 'supertokens-web-js/recipe/session'
import { hasEntraSession, getEntraIdToken } from '@/services/entraAuthService'

export async function getUpstreamJwt(): Promise<string | null> {
  if (hasEntraSession()) {
    return getEntraIdToken()
  }
  try {
    if (!(await Session.doesSessionExist())) return null
    return (await Session.getAccessToken()) || null
  } catch {
    return null
  }
}
